import { render, staticRenderFns } from "./FollowUpRecordsDrawer.vue?vue&type=template&id=1013b04e&scoped=true"
import script from "./FollowUpRecordsDrawer.vue?vue&type=script&lang=js"
export * from "./FollowUpRecordsDrawer.vue?vue&type=script&lang=js"
import style0 from "./FollowUpRecordsDrawer.vue?vue&type=style&index=0&id=1013b04e&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1013b04e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1013b04e')) {
      api.createRecord('1013b04e', component.options)
    } else {
      api.reload('1013b04e', component.options)
    }
    module.hot.accept("./FollowUpRecordsDrawer.vue?vue&type=template&id=1013b04e&scoped=true", function () {
      api.rerender('1013b04e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/drawer/FollowUpRecordsDrawer.vue"
export default component.exports